import React from "react";
import * as types from "../../../actions/types";
import {register, passwordResetRequest, passwordReset} from "../../../actions/auth-actions";
import {push} from "react-router-redux";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setNotification} from "../../../actions/notifications-actions";
import {Control, Errors, Form, actions} from "react-redux-form";
import qs from "query-string";
import PasswordResetForm from './forms/password-reset-form';
import PasswordResetRequestForm from './forms/password-reset-request-form';
import {Link, Route, Switch} from "react-router-dom";
import RegistrationForm from "./forms/registration-form";

class LecturerPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            finished: false
        }
    }

    resetRequestFormModel = 'forms.usersPasswordResetRequest';
    resetFormModel = 'forms.usersPasswordReset';

    passwordResetRequest = (values) => {
        this.props.resetValidity(this.resetRequestFormModel);
        let promise = new Promise((resolve, reject) => {
            this.props
                .passwordResetRequest({ lecturer: values })
                .then((response) => {
                    if (response.type === types.AUTH_PASSWORD_RESET_REQUEST_SUCCESS) {
                        this.props.setNotification('info','Za několik minut obdržíte e-mail s instrukcemi pro nastavení nového hesla.');
                        this.setState({...this.state, finished: true});
                        resolve();
                    } else {
                        if (response.payload.response) {
                            reject(response.payload.response.errors);
                        } else {
                            this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
                        }
                    }
                })
        });
        this.props.submitFields(this.resetRequestFormModel, promise);
    };

    passwordReset = (values) => {
        this.props.resetValidity(this.resetFormModel);

        let params = qs.parse(this.props.location.search);
        let resetValues = { lecturer: { ...values, reset_password_token: params['reset_password_token'] } };

        let promise = new Promise((resolve, reject) => {
            this.props
                .passwordReset(resetValues)
                .then((response) => {
                    if (response.type === types.AUTH_PASSWORD_RESET_SUCCESS) {
                        this.props.push('/lecturers/sign-in');
                        this.props.setNotification('success','Your password was changed successfully.');
                        resolve();
                    } else {
                        if (response.payload.response) {
                            reject(response.payload.response.errors);
                        } else {
                            this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
                        }
                    }
                })
        });
        this.props.submitFields(this.resetFormModel, promise);
    };

    render() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 m-auto'>
                        <h1 className='page-title'>Zapomenuté heslo</h1>
                        <div className='card auth-card'>
                            <div className='card-body'>
                            <Switch>
                                <Route path='/lecturers/password/request' exact render={() => <PasswordResetRequestForm model={this.resetRequestFormModel} onSubmit={this.passwordResetRequest}/>} />
                                <Route path='/lecturers/password/reset' exact render={() => <PasswordResetForm model={this.resetFormModel} onSubmit={this.passwordReset}/>} />
                            </Switch>
                                <small>
                                    <p>Už máte svůj profil? <Link to='/lecturers/sign-in'>Přihlaste se.</Link></p>
                                    <p>Chcete se přihlásit za konkrétní tím? <Link to='/students/sign-in'>Přihlaste se.</Link></p>
                                    <span><Link to='/lecturers/registration'>Registrace</Link></span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        submitFields: actions.submitFields,
        resetValidity: actions.resetValidity,
        setValidity: actions.setValidity,
        setNotification: setNotification,
        push: push,
        passwordResetRequest: passwordResetRequest,
        passwordReset: passwordReset
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LecturerPassword);
